import React from 'react';
import { Input } from 'antd';
import { CloseCircleIcon } from '../assets/icons/icons'; // adjust import

interface InlineInputProps {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onAdd: () => void;
  onCancel: () => void;
  autoFocus?: boolean;
}

const InlineInput: React.FC<InlineInputProps> = ({
  value,
  placeholder,
  onChange,
  onAdd,
  onCancel,
  autoFocus = true,
}) => {
  return (
    <div className='download-report-editor-input custom-no-border-input'>
      <Input
        value={value}
        placeholder={placeholder}
        size='small'
        autoFocus={autoFocus}
        onChange={(e) => onChange(e.target.value)}
        style={{
          flex: 1,
          border: 'none',
          height: '28px',
          padding: '0px',
        }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.stopPropagation();
            onAdd();
          } else if (e.key === 'Escape') {
            onCancel();
          }
        }}
      />

      <div
        onClick={(e) => {
          e.stopPropagation();
          onCancel();
        }}
      >
        <CloseCircleIcon
          style={{ background: 'var(--surface-container)' }}
          className='close-input-icon'
        />
      </div>
    </div>
  );
};

export default InlineInput;
